// This function will find comments that are in response to the current annotation
// and push them into an array that we will use to build out the comment thread.
// There is opportunity to optimize this and move it up to a higher level, possibly
// in our annotation provider, when we start to use this for teacher grading views where
// there might be many more annotation comments, but keeping it like this since
// we are only supporting the student view for now.
export const getAnnotationsCommentThread = (
  shouldGetComments,
  annotationComments,
  idToMatch,
) => {
  if (!shouldGetComments) return null;

  const commentThread = [];
  const buildCommentThread = (annotationComments, idToMatch) => {
    if (!annotationComments?.length) return;

    const commentInThread = annotationComments.find(
      (comment) => comment.in_response_to.id === idToMatch,
    );
    if (commentInThread) {
      commentThread.push(commentInThread);
      buildCommentThread(
        annotationComments,
        commentThread[commentThread.length - 1]?.id,
      );
    }
  };

  buildCommentThread(annotationComments, idToMatch);
  return commentThread;
};

export default getAnnotationsCommentThread;
